module.exports = ".btn-mob{\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n}\r\n.label-bold{\r\n    font-weight: 600 !important;\r\n}\r\n.btn-mob-top{\r\n    width: 100%;\r\n    margin-bottom: 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/search/location/location.component.css
// module id = ./src/app/modules/search/location/location.component.css
// module chunks = main